
import { TranslationSet } from '../../types';

export const galleryCategories: TranslationSet = {
  'gallery.category': {
    en: 'Category',
    ja: 'カテゴリー',
    es: 'Categoría',
    zh: '类别',
    fa: 'دسته‌بندی'
  },
  'gallery.recentPhoto': {
    en: 'Recent Photo',
    ja: '最近の写真',
    es: 'Foto reciente',
    zh: '最近的照片',
    fa: 'عکس های اخیر'
  },
  'gallery.milestonePhoto': {
    en: 'Milestone Photo',
    ja: 'マイルストーン写真',
    es: 'Foto de hito',
    zh: '里程碑照片',
    fa: 'عکس مراحل رشد'
  },
  'gallery.firstYear': {
    en: 'First Year',
    ja: '最初の年',
    es: 'Primer año',
    zh: '第一年',
    fa: 'سال اول'
  },
  'gallery.familyMoments': {
    en: 'Family Moments',
    ja: '家族の瞬間',
    es: 'Momentos familiares',
    zh: '家庭时刻',
    fa: 'لحظات خانوادگی'
  },
  'gallery.specialEvents': {
    en: 'Special Events',
    ja: '特別なイベント',
    es: 'Eventos especiales',
    zh: '特殊事件',
    fa: 'رویدادهای ویژه'
  }
};
